import styled from "styled-components";

export const LayoutStyled = styled.div`
  font-family: Nunito Sans;
  max-width: 552px;
  margin: 36px auto;
  padding: 0 24px;
  p {
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 22px;
    text-align: center;
    letter-spacing: 0.02em;
  }

  .my-history-menu {
    list-style-type: none;
    margin: 32px 0 0;
    padding: 0;
    li {
      color: black;
      font-size: 16px;
      font-style: normal;
      font-weight: 800;
      letter-spacing: 0.03em;
      text-transform: uppercase;
      border-bottom: 1px solid #9D9D9D;
      padding: 20px 0;
      position: relative;
      cursor: pointer;
      a {
        text-decoration: none;
      }
      svg {
        position: absolute;
        right: 0;
        top: 26px;
      }
    }
  }
`;